import { Subscriber } from "./Subscriber.js";
class Observable {
  constructor(producerFunction) {
    this._producerFunction = producerFunction;
  }
  subscribe(observer, e, c) {
    const partialObserver = {
      next: typeof observer === "object" ? observer.next : observer,
      error: typeof observer === "object" ? observer.error : e,
      complete: typeof observer === "object" ? observer.complete : c
    };
    const internalSubscriber = new Subscriber({
      next: (data) => {
        partialObserver.next?.(data);
      },
      error: (e2) => {
        partialObserver.error?.(e2);
      },
      complete: () => {
        partialObserver.complete?.();
      }
    });
    if (this._producerFunction) {
      const teardownLogic = this._producerFunction(internalSubscriber);
      if (teardownLogic) {
        internalSubscriber.add(teardownLogic);
      }
    }
    return internalSubscriber;
  }
  // complete 되야지만 마지막 처리된다!
  toPromise() {
    return new Promise((resolve, reject) => {
      let lastValue;
      let subscription;
      subscription = this.subscribe({
        next: (value) => {
          lastValue = value;
        },
        error: (err) => {
          reject(err);
          subscription.unsubscribe();
        },
        complete: () => {
          resolve(lastValue);
          subscription.unsubscribe();
        }
      });
    });
  }
  pipe(...operators) {
    if (operators.length === 0) {
      return this;
    }
    return operators.reduce((prev, operator) => operator(prev), this);
  }
}
export {
  Observable
};
//# sourceMappingURL=Observable.js.map
